import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, DropdownButton, MenuItem, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { branch, compose, lifecycle, renderNothing, withHandlers, withProps, withStateHandlers } from "recompose";
import { bindActionCreators } from 'redux';
import { searchTileType } from '../../../../../constants';
import { mapRecommendedContent, mapRecommendedResult } from '../../../../../services';
import { businessActions, businessSelector, publicBusinessContentSelector, publicNonCpdContentSelector } from '../../../../../state/modules/business';
import { searchTileActions, searchTileSelector } from '../../../../../state/modules/search-tile';
import { isUserFinancialAdvisorSelector } from '../../../../../state/modules/user/selectors';
import { noCapMap, pluralise } from '../../../../../utils';
import { Icon } from '../../../../components';
import SearchForm from '../../../../components/search-form';
import Loading from '../../../loading';
import ContentTile from '../../partials/content-tile';
import CourseTile from '../../partials/course-tile';
import AssociationFilter from './association-filter';
import CpdCategoryFilter from './cpd-category-filter';
import PublisherFilter from './publisher-filter';
import TaskBox from './task-box';

const taskContentSorting = {
  publicationDateDesc: {
    displayName: 'Newest first',
    field: 'publicationDate',
    order: 'desc'
  },
  selectedFirst: {
    displayName: 'Selected first',
    field: 'isSelected',
    order: 'desc'
  }
}

const SetContent = ({
  task,
  stepTo,
  isFetchingContent,
  hits,
  contents,
  mapRecommended,
  noMoreToLoad,
  loadMoreContent,
  toggleSearchTile,
  toggleBusinessLibraryContent,
  togglePublisherFilter,
  toggleCpdCategoryFilter,
  toggleAssociationFilter,
  showPublisherFilter,
  showCpdCategoryFilter,
  showAssociationFilter,
  attachPublisherFilterRef,
  attachCpdCategoryFilterRef,
  attachAssociationFilterRef,
  publisherFilterRef,
  cpdCategoryFilterRef,
  selectedPublishers,
  selectedBusinessId,
  selectedCpdCategory,
  selectedAssociations,
  onPublisherFilterChange,
  onCpdCategoryFilterChange,
  onAssociationFilterChange,
  setAllPublisher,
  setAllCpdCategory,
  setAllAssociation,
  searchQuery,
  updateSearchQuery,
  filterApplied,
  clearFilters,
  content,
  sortBy,
  sort,
  isUserFinancialAdvisor,
  businessLibraryContent
}) => (
    <div id='set-content'>
      <TaskBox task={task} stepTo={stepTo} />
      <Row className='no-gutter'>
        <Col xs={12} md={6}>
          <h2 className='name'>Select Content</h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Col xs={12} md={4}>
          <p id='content-result-count'>{`Showing ${content.publishersContent.length} ${pluralise('result', content.publishersContent.length)}`}</p>
          {
            filterApplied.length > 0 ?
              <DropdownButton
                id='filter-applied-badge'
                title={`${filterApplied.length} ${pluralise('Filter', filterApplied.length)} Applied`}
                variant='danger'
              >
                {
                  fp.map(
                    ({ detail, clearHandler }, index) => <MenuItem key={`filter-${index}`} onClick={clearHandler}>{detail}<Icon icon='close-thick' /></MenuItem>
                  )(filterApplied)
                }
              </DropdownButton> : null
          }
        </Col>
        <Col xs={12} md={8} className='filters row-reverse no-height'>
          <div id='search'><SearchForm id='search-desktop' label='Search Content' className='searchDesktop' searchQuery={searchQuery} onSearchChange={updateSearchQuery} /></div>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Col xs={12} mdOffset={8} md={4} className='filters row-reverse'>
          <div>
            <div id='sort-by-text'><p>Sort by</p></div>
            <select id='sort-by' value={sort} required onChange={(e) => sortBy(e)}>
              {
                fp.map((sortingKey) =>
                  <option key={sortingKey} value={sortingKey}>
                    {fp.get(sortingKey)(taskContentSorting).displayName}
                  </option>
                )(fp.keys(taskContentSorting))
              }
            </select>
          </div>
        </Col>
        <Col xs={12} md={8} className='filters pull-up'>
          <div id='filter-text'><p>Filter by</p></div>
          {
            isUserFinancialAdvisor ?
              <div id='association-filter-button' className={showAssociationFilter ? 'open' : ''} ref={attachAssociationFilterRef} onClick={toggleAssociationFilter}>
                Association
                {
                  showAssociationFilter ?
                    <Icon icon='chevron-up-large' /> :
                    <Icon icon='chevron-down-large' />
                }
              </div> : null
          }
          <div id='cpd-category-filter-button' className={showCpdCategoryFilter ? 'open' : ''} ref={attachCpdCategoryFilterRef} onClick={toggleCpdCategoryFilter}>
            CPD Category
            {
              showCpdCategoryFilter ?
                <Icon icon='chevron-up-large' /> :
                <Icon icon='chevron-down-large' />
            }
          </div>
          {
            isUserFinancialAdvisor ?
              <div id='publisher-filter-button' className={showPublisherFilter ? 'open' : ''} ref={attachPublisherFilterRef} onClick={togglePublisherFilter}>
                Publisher
                {
                  showPublisherFilter ?
                    <Icon icon='chevron-up-large' /> :
                    <Icon icon='chevron-down-large' />
                }
              </div> : null
          }
        </Col>
      </Row>
      <Row id='contents' className='no-gutter row-slider'>
        <Col className='filter-panels' xs={11} sm={8} md={4}>
          <PublisherFilter
            show={showPublisherFilter}
            selectedPublishers={selectedPublishers}
            selectedBusinessId={selectedBusinessId}
            setAll={setAllPublisher}
            changeHandler={onPublisherFilterChange} />
          <CpdCategoryFilter
            show={showCpdCategoryFilter}
            selectedCpdCategory={selectedCpdCategory}
            setAll={setAllCpdCategory}
            changeHandler={onCpdCategoryFilterChange} />
          <AssociationFilter
            show={showAssociationFilter}
            setAll={setAllAssociation}
            selectedAssociations={selectedAssociations}
            changeHandler={onAssociationFilterChange} />
        </Col>
        <Col xs={1} sm={4} md={8}></Col>
        {
          (isFetchingContent && hits === 0) ? <Loading /> :
            hits > 0 ?
              noCapMap((searchTile, index) =>
                <Col key={index} xs={12} sm={4} md={3} id='thin-padding' className='col-xl-2-4'>
                  {
                    searchTile.type === searchTileType.Course ?
                      <CourseTile {...searchTile} toggleHandler={() => toggleSearchTile(searchTile)} /> : null
                  }
                  {
                    searchTile.type === searchTileType.Content ?
                      <ContentTile {...searchTile} removeContentHandler={() => toggleSearchTile(searchTile)} openInNewWindow={true} searchMode={true} /> : null
                  }
                </Col>
              )(fp.flow(
                fp.map(
                  (searchTile) => ({
                    ...searchTile,
                    completionStatus: 'Unknown'
                  })
                )
              )(content.publishersContent)) :
              <p className='no-data'>No content found.</p>
        }
      </Row>
      {
        noMoreToLoad ? null : <Row className='card-gutter row-slider bottom-gap'>
          <Col className='flex-center'>
            <Button onClick={loadMoreContent}>
              {
                isFetchingContent ? <Loading /> :
                  "Load More"
              }
            </Button>
          </Col>
        </Row>
      }
      <Row className='no-gutter row-slider bottom-gap'>
        <h2>Business Library</h2>
        {
          noCapMap((content, index) =>
            <Col key={index} xs={12} sm={4} md={3} id='thin-padding' className='col-xl-2-4'>
              <ContentTile {...content} removeContentHandler={() => toggleBusinessLibraryContent(content)} openInNewWindow={true} searchMode={true} />
            </Col>
          )(
            fp.flow(
              fp.map(
                (content) => ({
                  ...content,
                  completionStatus: 'Unknown'
                })
              )
            )(content.businessLibraryContent)
          )
        }
      </Row>
    </div>
  )

const getCpdCategoryFilterDetail = (aoas, clearHandler) => {
  const detail = `${aoas.length} ${pluralise('category', aoas.length)}`
  return aoas.length > 0 ? {
    detail,
    clearHandler
  } : null
}

const getPublisherFilterDetail = (publishers, businessId, clearHandler) => {
  const publisherCount = publishers.length
  const businessCount = businessId === undefined ? 0 : 1
  const totalCount = publisherCount + businessCount
  const detail = `${totalCount} ${pluralise('publisher', totalCount)}`
  return totalCount > 0 ? {
    detail,
    clearHandler
  } : null
}

const getAssociationFilterDetail = (associations, clearHandler) => {
  const detail = `${associations.length} ${pluralise('association', associations.length)}`
  return associations.length > 0 ? {
    detail,
    clearHandler
  } : null
}

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  isUserFinancialAdvisor: isUserFinancialAdvisorSelector(state),
  industryCpdCategorys: state.industry.cpdCategorys,
  results: searchTileSelector(state),
  noMoreToLoad: searchTileSelector(state).searchTiles.length === searchTileSelector(state).hits,
  isFetchingContent: state.searchTile.isFetching,
  hits: searchTileSelector(state).hits,
  mapRecommended: mapRecommendedContent(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state)),
  content: { 
    // Select any content that is not belong to business, those business library content will be displayed in another section.
    publishersContent: 
      mapRecommendedResult(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state))(searchTileSelector(state))
        .filter((content) => {
          const business = businessSelector(state);

          return content.businessId === undefined || content.businessId !== business.id;
        }),
    // We need a section for Business Library only content, select any content from current Business Library and map necessary metadata to the content.
    businessLibraryContent: 
      [
        ...mapRecommendedContent(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state))(publicBusinessContentSelector(state)),
        ...mapRecommendedContent(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state))(publicNonCpdContentSelector(state))
      ]
      .filter((content) => {
        const business = businessSelector(state);

        return business.id === content.businessId;
      }),
  },
  businessLibraryContent: [
    ...mapRecommendedResult(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state))(searchTileSelector(state)),
    ...publicNonCpdContentSelector(state)
  ]
})

const mapDispatchToProps = (dispatch) => ({
  getContent: bindActionCreators(searchTileActions.searchTile.get, dispatch),
  getBusinessLibraryContent: bindActionCreators(businessActions.business.content.get, dispatch),
  getNonCpdContent: bindActionCreators(businessActions.business.content.getNonCpdContent, dispatch),
  loadMore: bindActionCreators(searchTileActions.searchTile.loadMore, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ results }) => ({
      contents: results.content,
      courses: results.events
    })
  ),
  withProps(
    ({ industryCpdCategorys, task, contents, tiles, content, mapRecommended }) => ({
      industryCpdCategorysId: fp.flow(
        fp.map(
          ({ id }) => id
        ),
        fp.join(',')
      )(industryCpdCategorys),
      content: {
        publishersContent: content.publishersContent.map((content) => {
          const isSelected = task.searchTiles.value.find(({ id, type }) => content.id === id && type === content.type)
          
          if (isSelected) {
            return {
              ...content,
              selected: true
            }
          }

          return content
        }),
        businessLibraryContent: content.businessLibraryContent.map((content) => {
          const isSelected = task.businessLibraryContent.value.find(({ id }) => content.id === id)

          if (isSelected) {
            return {
              ...content,
              selected: true
            }
          }

          return content
        })
      }
    })
  ),
  branch(
    ({ business }) => !business,
    renderNothing
  ),
  lifecycle({
    componentDidMount() {
      const {
        getContent,
        task,
        business,
        getNonCpdContent,
        getBusinessLibraryContent
      } = this.props;
      getNonCpdContent(business.id);
      getBusinessLibraryContent(business.id);
      getContent(0, {
        status: 'Published',
        cpdCategorys: this.props.industryCpdCategorysId,
        isRecommendOnly: true,
        take: 12,
        searchTileType: [searchTileType.Content, searchTileType.Course].join(','),
        sort: task.selectedIds.value.length > 0 ?
          fp.join(',', [taskContentSorting.selectedFirst.field, taskContentSorting.selectedFirst.order]) :
          fp.join(',', [taskContentSorting.publicationDateDesc.field, taskContentSorting.publicationDateDesc.order]),
        selectedIds: fp.join(',')(task.selectedIds.value)
      });
    }
  }),
  withHandlers({
    toggleSearchTile: ({ onTaskEdited, task, contents }) => (tile) => {
      const selectedSearchTiles = task.searchTiles.value
      const nextSearchTiles = fp.find(({ type, id }) => id === tile.id && type === tile.type)(selectedSearchTiles) ?
        fp.filter(
          ({ type, id }) => id !== tile.id || type !== tile.type
        )(task.searchTiles.value) :
        task.searchTiles.value.concat([tile])
      const nextSelectedIds = fp.find(id => id === tile.searchTileId)(task.selectedIds.value) ?
        fp.remove(id => id === tile.searchTileId)(task.selectedIds.value) :
        task.selectedIds.value.concat(tile.searchTileId)
      onTaskEdited('searchTiles', nextSearchTiles)
      onTaskEdited('selectedIds', nextSelectedIds)
    },
    toggleBusinessLibraryContent: ({ onTaskEdited, task }) => (content) => {
      const currentBusinessLibraryContent = task.businessLibraryContent.value

      const alreadySelected = fp.find(({ id }) => id === content.id)(currentBusinessLibraryContent)

      const removeContent = () => currentBusinessLibraryContent.filter(({ id }) => id !== content.id)

      const addContent = () => currentBusinessLibraryContent.concat(content)

      const updatedBUsinessLibraryContent = alreadySelected ? removeContent() : addContent()

      onTaskEdited('businessLibraryContent', updatedBUsinessLibraryContent)
    }
  }),
  withStateHandlers(
    {
      showPublisherFilter: undefined,
      showCpdCategoryFilter: undefined,
      showAssociationFilter: undefined,
      publisherFilterRef: undefined,
      cpdCategoryFilterRef: undefined,
      associationFilterRef: undefined
    },
    {
      togglePublisherFilter: ({ showPublisherFilter, showCpdCategoryFilter, showAssociationFilter }) => () => ({
        showPublisherFilter: !showPublisherFilter,
        showCpdCategoryFilter: showCpdCategoryFilter === undefined ? undefined : false,
        showAssociationFilter: showAssociationFilter === undefined ? undefined : false
      }),
      toggleCpdCategoryFilter: ({ showCpdCategoryFilter, showPublisherFilter, showAssociationFilter }) => () => ({
        showCpdCategoryFilter: !showCpdCategoryFilter,
        showPublisherFilter: showPublisherFilter === undefined ? undefined : false,
        showAssociationFilter: showAssociationFilter === undefined ? undefined : false
      }),
      toggleAssociationFilter: ({ showCpdCategoryFilter, showPublisherFilter, showAssociationFilter }) => () => ({
        showAssociationFilter: !showAssociationFilter,
        showPublisherFilter: showPublisherFilter === undefined ? undefined : false,
        showCpdCategoryFilter: showCpdCategoryFilter === undefined ? undefined : false
      }),
      attachPublisherFilterRef: () => (ref) => ({
        publisherFilterRef: ref
      }),
      attachCpdCategoryFilterRef: () => (ref) => ({
        cpdCategoryFilterRef: ref
      }),
      attachAssociationFilterRef: () => (ref) => ({
        associationFilterRef: ref
      })
    }
  ),
  withStateHandlers(({ task }) =>
    ({
      selectedAssociations: [],
      selectedPublishers: [],
      selectedBusinessId: undefined,
      selectedCpdCategory: [],
      searchQuery: undefined,
      searchDebounce: undefined,
      sort: task.selectedIds.value.length > 0 ? 'selectedFirst' : 'publicationDateDesc'
    }),
    {
      toggleAssociation: ({ selectedAssociations }) => (association) => ({
        selectedAssociations: fp.contains(association)(selectedAssociations) ?
          fp.filter(
            (selected) => selected !== association
          )(selectedAssociations) :
          selectedAssociations.concat([association])
      }),
      togglePublisher: ({ selectedPublishers }) => (publisherId) => ({
        selectedPublishers: fp.contains(publisherId)(selectedPublishers) ?
          fp.filter(
            (id) => id !== publisherId
          )(selectedPublishers) :
          selectedPublishers.concat([publisherId])
      }),
      toggleBusiness: ({ selectedBusinessId }) => (businessId) => ({
        selectedBusinessId: selectedBusinessId === businessId ? undefined : businessId
      }),
      toggleCpdCategory: ({ selectedCpdCategory }) => (cpdCategoryId) => ({
        selectedCpdCategory: fp.contains(cpdCategoryId)(selectedCpdCategory) ?
          fp.filter(
            (id) => id !== cpdCategoryId
          )(selectedCpdCategory) :
          selectedCpdCategory.concat([cpdCategoryId])
      }),
      unsetPublisher: () => () => ({ selectedPublishers: [] }),
      unsetAssociation: () => () => ({ selectedAssociations: [] }),
      unsetBusiness: () => () => ({ selectedBusinessId: undefined }),
      unsetCpdCategory: () => () => ({ selectedCpdCategory: [] }),
      setAllPublisher: () => (publishers, businessId) => ({
        selectedPublishers: publishers,
        selectedBusinessId: businessId
      }),
      setAllCpdCategory: () => (cpdCategorys) => ({
        selectedCpdCategory: cpdCategorys
      }),
      setAllAssociation: () => (associations) => ({
        selectedAssociations: associations
      }),
      updateSearchQuery: () => (e) => ({
        searchQuery: e.target.value
      }),
      setSearchDebounce: () => (searchDebounce) => ({
        searchDebounce
      }),
      clearFilters: () => () => ({
        selectedCpdCategory: [],
        selectedPublishers: [],
        selectedBusinessId: undefined
      }),
      onSortByChange: () => (value) => ({
        sort: value
      })
    }
  ),
  withHandlers({
    sortBy: ({ onSortByChange }) => (e) => {
      onSortByChange(e.target.value)
    },
    onPublisherFilterChange: ({ selectedPublishers, togglePublisher, toggleBusiness }) => (publisherIdOrBusinessId, isBusiness) => {
      if (isBusiness) {
        toggleBusiness(parseInt(publisherIdOrBusinessId, 10))
      } else {
        togglePublisher(parseInt(publisherIdOrBusinessId, 10))
      }
    },
    onCpdCategoryFilterChange: ({ selectedCpdCategory, toggleCpdCategory }) => (cpdCategoryId) => {
      toggleCpdCategory(cpdCategoryId)
    },
    onAssociationFilterChange: ({ toggleAssociation }) => (association) => {
      toggleAssociation(association)
    }
  }),
  withProps(
    ({ selectedCpdCategory, selectedPublishers, selectedAssociations, selectedBusinessId, searchQuery, unsetPublisher, unsetAssociation, unsetBusiness, unsetCpdCategory, sort }) => ({
      filter: {
        status: 'Published',
        take: 12,
        businessId: selectedBusinessId,
        associations: selectedAssociations.join(','),
        searchTileType: [searchTileType.Content, searchTileType.Course].join(','),
        cpdCategorys: selectedCpdCategory.join(','),
        publishers: selectedPublishers.join(','),
        titleTags: searchQuery,
        sort: fp.join(',', [fp.get(sort)(taskContentSorting).field, fp.get(sort)(taskContentSorting).order])
      },
      filterApplied: fp.flow(
        fp.filter(
          detail => !fp.isEmpty(detail)
        )
      )([
        getCpdCategoryFilterDetail(selectedCpdCategory, () => {
          unsetCpdCategory()
        }),
        getPublisherFilterDetail(selectedPublishers, selectedBusinessId, () => {
          unsetPublisher()
          unsetBusiness()
        }),
        getAssociationFilterDetail(selectedAssociations, () => {
          unsetAssociation()
        })
      ])
    })
  ),
  withHandlers({
    refetchData: ({ searchDebounce, getContent, filter, setSearchDebounce, task }) => () => {
      searchDebounce && searchDebounce.cancel()
      const debounce = fp.debounce(500)(
        () => getContent(0, { ...filter, selectedIds: fp.join(',')(task.selectedIds.value) })
      )
      setSearchDebounce(debounce)
      debounce()
    },
    loadMoreContent: ({ loadMore, results, filter, task }) => () => {
      loadMore(results.searchTiles.length, { ...filter, selectedIds: fp.join(',')(task.selectedIds.value) });
    }
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        filter,
        refetchData
      } = this.props;

      if (JSON.stringify(filter) !== JSON.stringify(prevProps.filter)) {
        refetchData()
      }
    }
  })
)(SetContent)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/set-content.js